import { Button } from "@/components/ui/button";

interface HeroContentProps {
  isPro: boolean;
  onShowWaitlist: () => void;
}

export const HeroContent = ({ isPro, onShowWaitlist }: HeroContentProps) => {
  if (isPro) {
    return (
      <>
        <h1 className="font-mono text-2xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-primary mb-6 leading-tight">
          Vous en avez marre des
          <br className="hidden sm:block" />
          réservations au téléphone ?
          <br className="hidden sm:block" />
          <span className="text-secondary block sm:inline mt-2 sm:mt-0">
            On a caché un calendrier magique dans l'Aisne.
          </span>
        </h1>
        <h2 className="text-xl sm:text-2xl md:text-3xl text-gray-800 mb-4 w-full">
          Simplifiez vos réservations avec NLocale
        </h2>
        <h3 className="text-lg sm:text-xl md:text-2xl text-gray-600 mb-8 w-full">
          La solution locale pour les pros de l'Aisne
        </h3>
      </>
    );
  }

  return (
    <>
      <h1 className="font-mono text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-primary mb-6 leading-tight">
        L'Aisne a plus de secrets que le trône de fer.
        <br className="hidden sm:block" />
        <span className="text-secondary block sm:inline mt-2 sm:mt-0">
          Mais on va tout vous dire...
        </span>
      </h1>
      <h2 className="text-xl sm:text-2xl md:text-3xl text-gray-800 mb-4 w-full">
        Découvrez les trésors cachés de l'Aisne
      </h2>
      <h3 className="text-lg sm:text-xl md:text-2xl text-gray-600 mb-8 w-full">
        Des expériences authentiques sélectionnées pour vous
      </h3>
    </>
  );
};